import React, { useState, useEffect } from "react";
import { IoBagHandle } from "react-icons/io5";
import Leftsidebar from "../sidebar/leftsidebar";
import LeftResponsivesidebar from "../sidebar/left-responsive";
import Headmenu from "../sidebar/headmenu";
import {
  getCart,
  updateCartItem,
  removeCartItem,
  checkoutCart,
  applyWalletToCheckout,
} from "../../api/cartApi";
import { getWalletBalance, getWalletExchangeRate } from "../services/subscriptionService";
import { useLocation,useNavigate  } from "react-router-dom";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { ADDRESS_DRAFT_KEY } from "../becomesell/ShopperAdders";

// Same rules as the API's apply-wallet: Stripe needs a card charge worth $0.50 by its own rate, so other
// currencies keep $1 by the admin's rate; coin values round down and coins taken round up
const MIN_CARD_CHARGE = 0.5;
const MIN_CONVERTED_CARD_CHARGE = 1;
const floorMoney = (value) => Math.floor(Number((value * 100).toFixed(6))) / 100;
const ceilMoney = (value) => Math.ceil(Number((value * 100).toFixed(6))) / 100;

// Example options
const availableSizes = ["7", "8", "9", "10", "11", "12", "48"];
const availableColors = ["Blue", "Black", "Red", "White"];
const CURRENCY_SYMBOLS = { usd: "$", inr: "₹", eur: "€", gbp: "£" };

const OrderReviewPage = () => {
  const [products, setProducts] = useState([
    {
      id: 1,
      name: "CRI TRIUMPH Cricket Shoes For Men",
      image: "/image/shoeimg.png",
      originalPrice: 180,
      discountedPrice: 145,
      quantity: 1,
      size: "",
      color: "",
    },
    {
      id: 2,
      name: "CRI TRIUMPH Cricket Shoes For Men",
      image: "/image/shoeimg.png",
      originalPrice: 180,
      discountedPrice: 145,
      quantity: 1,
      size: "",
      color: "",
    },
    {
      id: 3,
      name: "CRI TRIUMPH Cricket Shoes For Men",
      image: "/image/shoeimg.png",
      originalPrice: 180,
      discountedPrice: 145,
      quantity: 1,
      size: "",
      color: "",
    },
  ]);
  const [loading, setLoading] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  const [orderData, setOrderData] = useState(null);
  const [shippingAddress, setShippingAddress] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
// Stripe hooks (same pattern used in donation.js)
  const stripe = useStripe();
  const elements = useElements();
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [payLoading, setPayLoading] = useState(false);
  const [walletBalance, setWalletBalance] = useState(0);
  const [useWallet, setUseWallet] = useState(false);
  const [walletRate, setWalletRate] = useState(null);
  const [showTaxDetails, setShowTaxDetails] = useState(false);

  // Re-read the balance when the buyer comes back from topping up the wallet in another tab
  useEffect(() => {
    const loadBalance = () => getWalletBalance().then(setWalletBalance).catch(() => {});
    loadBalance();
    window.addEventListener("focus", loadBalance);
    return () => window.removeEventListener("focus", loadBalance);
  }, []);

  useEffect(() => {
    let mounted = true;
    async function load() {
      setLoading(true);
      try {
        const res = await getCart();
        const items =
          res?.cart_items ||
          res?.cartItems ||
          res?.items ||
          res?.result?.cart_items ||
          [];
        if (mounted) setCartItems(Array.isArray(items) ? items : []);
      } catch (err) {
        console.error("Failed to load cart:", err);
      } finally {
        if (mounted) setLoading(false);
      }
    }
    load();
    return () => (mounted = false);
  }, []);
  useEffect(() => {
    // ✅ Get checkout API response and shipping info passed from previous page
    const readSaved = (key) => {
      try {
        return JSON.parse(sessionStorage.getItem(key) || "null");
      } catch {
        return null;
      }
    };
    // Navigation state is lost on refresh; ShopperAdders also saves both in sessionStorage
    const checkoutData = location.state?.checkoutResponse || readSaved("checkoutResponse");
    const addressData = location.state?.shippingAddress || readSaved("shippingAddress");

    // if (checkoutData?.success && checkoutData?.result) {
    //   setOrderData(checkoutData.result);
    // }
    if (checkoutData) {
    setOrderData(checkoutData); // <-- FIXED
    setUseWallet(Number(checkoutData.wallet_applied) > 0);
  }
    if (addressData) {
      setShippingAddress(addressData);
    }
  }, [location.state]);

  // if (!orderData) {
  //   return (
  //     <div className="p-6 text-center text-gray-500">
  //       Loading order details...
  //     </div>
  //   );
  // }
  const order = orderData?.orders?.[0];
  const allOrders = orderData?.orders || [];
  const sumPricing = (key) =>
    allOrders.reduce((sum, o) => sum + (Number(o?.pricing?.[key]) || 0), 0);
  const subtotal = sumPricing("subtotal").toFixed(2);
  const delivery = sumPricing("delivery_charges").toFixed(2);
  const tax = sumPricing("tax_amount").toFixed(2);
  // The same tax rule across several sellers' orders is shown once
  const taxBreakdown = Object.values(
    allOrders.flatMap((o) => o?.pricing?.tax_breakdown || []).reduce((groups, rule) => {
      const group = (groups[`${rule.jurisdiction}|${rule.name}|${rule.rate}`] ||= { name: rule.name, rate: rule.rate, amount: 0, components: {} });
      group.amount += rule.tax_amount;
      rule.components.forEach(({ name, rate, amount }) => {
        (group.components[name] ||= { name, rate, amount: 0 }).amount += amount;
      });
      return groups;
    }, {})
  );
  const total = (
    Number(orderData?.total_amount) || sumPricing("final_amount")
  ).toFixed(2);
  const allItems = allOrders.flatMap((o) =>
    (o.order_items || o.items || []).map((it) => ({ ...it, seller: o.seller }))
  );
  const currencySymbol = CURRENCY_SYMBOLS[allOrders[0]?.seller?.currency?.toLowerCase()] || "$";
  const imageByProductId = cartItems.reduce((map, it) => {
    const url = it.product?.product_media?.[0]?.url;
    if (url) map[it.product_id] = url;
    return map;
  }, {});
  const hasOrder = allOrders.length > 0;
  const paymentSucceeded = paymentStatus === "Payment successful!";

  // Wallet coins are USD; orders in another currency use the admin's exchange rate (null = wallet unavailable)
  const orderCurrency = (allOrders[0]?.seller?.currency || "usd").toUpperCase();
  useEffect(() => {
    if (orderCurrency === "USD") {
      setWalletRate(1);
      return;
    }
    setWalletRate(null);
    getWalletExchangeRate(orderCurrency).then(setWalletRate).catch(() => setWalletRate(null));
  }, [orderCurrency]);

  // Coins already held for this checkout are still usable by it
  const heldCoins = Number(orderData?.wallet_coins) || 0;
  const availableCoins = Number((walletBalance + heldCoins).toFixed(2));
  const coinsValue = walletRate ? floorMoney(availableCoins * walletRate) : 0;
  const orderTotal = Number(total);
  let walletApplied = useWallet ? Math.min(coinsValue, orderTotal) : 0;
  const minCardCharge = walletRate === 1 ? MIN_CARD_CHARGE : ceilMoney(MIN_CONVERTED_CARD_CHARGE * (walletRate || 1));
  const cardShare = orderTotal - walletApplied;
  if (cardShare > 0 && cardShare < minCardCharge) walletApplied = Math.max(orderTotal - minCardCharge, 0);
  walletApplied = Number(walletApplied.toFixed(2));
  const walletCoinsUsed = walletRate ? Math.min(ceilMoney(walletApplied / walletRate), availableCoins) : 0;
  const amountToPay = Number((orderTotal - walletApplied).toFixed(2));

   // --- Stripe payment handler (mirrors the donation.js logic) ---
  const handlePayNow = async (e) => {
    e?.preventDefault?.();
    // If user chose wallet or backend already processed payment, you may skip Stripe.
    // We'll check for a client_secret or requires_action to know if Stripe is required.
    try {
      setPaymentStatus(null);
      setPayLoading(true);

      // ensure stripe & elements loaded
      if (!stripe || !elements) {
        setPaymentStatus("Stripe has not loaded. Please try again later.");
        setPayLoading(false);
        return;
      }

      // We expect checkout response to contain either:
      // - client_secret (when a PaymentIntent was created) and maybe requires_action true
      // - or payment already confirmed by wallet and no client_secret
      let currentOrder = orderData;
      let clientSecret =
        orderData?.client_secret ||
        orderData?.payment_intent_client_secret ||
        orderData?.payment_intent?.client_secret;

      if (hasOrder && (useWallet || heldCoins > 0)) {
        const response = await applyWalletToCheckout(orderData.payment_intent_id, useWallet);
        if (!response?.success) {
          setPaymentStatus(response?.message || "Could not apply wallet coins. Please try again.");
          getWalletBalance().then(setWalletBalance).catch(() => {});
          setPayLoading(false);
          return;
        }
        const applied = response.result;
        currentOrder = {
          ...orderData,
          wallet_applied: applied.wallet_applied,
          wallet_coins: applied.wallet_coins,
          wallet_balance: applied.wallet_balance,
          wallet_reference: applied.wallet_reference,
          ...(applied.paid
            ? { paid: true, payment_method: "wallet" }
            : { client_secret: applied.client_secret }),
        };
        sessionStorage.setItem("checkoutResponse", JSON.stringify(currentOrder));
        setOrderData(currentOrder);
        setWalletBalance(applied.wallet_balance);
        if (applied.paid) {
          sessionStorage.removeItem(ADDRESS_DRAFT_KEY);
          navigate("/orderReceipt", { replace: true, state: { orderData: currentOrder, shippingAddress } });
          return;
        }
        if (Math.abs(applied.amount_to_pay - amountToPay) > 0.005) {
          setPaymentStatus("Your wallet balance changed. Please review the updated amount and press Pay Now again.");
          setPayLoading(false);
          return;
        }
        clientSecret = applied.client_secret;
      }

      // Cart checkout always creates a Stripe PaymentIntent, so a missing secret means the order data
      // didn't reach this page; never treat that as a completed order
      if (!hasOrder || !clientSecret) {
        setPaymentStatus("Order details are missing. Please go back and press Pay Now again.");
        setPayLoading(false);
        return;
      }

      // Confirm card payment with the client secret
      const cardElement = elements.getElement(CardElement);
      if (!cardElement) {
        setPaymentStatus("Please enter card details.");
        setPayLoading(false);
        return;
      }

      const result = await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: cardElement,
        },
      });

      if (result.error) {
        console.error("Stripe confirm error:", result.error);
        setPaymentStatus(`Payment failed: ${result.error.message}`);
        setPayLoading(false);
        return;
      }

      // result.paymentIntent exists on success
      if (result.paymentIntent && result.paymentIntent.status === "succeeded") {
        setPaymentStatus("Payment successful!");
        sessionStorage.removeItem(ADDRESS_DRAFT_KEY);
        // Optionally show toast, refresh cart, navigate to order summary page
        // If the backend returned order data earlier, we already have it in orderData; else fetch orders
        navigate("/orderReceipt", { replace: true, state: { orderData: currentOrder, paymentIntent: result.paymentIntent } });
      } else {
        // If paymentIntent.status is not succeeded, still show status
        setPaymentStatus(`Payment status: ${result.paymentIntent?.status || "unknown"}`);
      }
    } catch (err) {
      console.error("Checkout payment error:", err);
      setPaymentStatus("Payment failed. Please try again.");
    } finally {
      setPayLoading(false);
    }
  };

  // Basic CardElement styling (you can adapt)
  const cardElementOptions = {
    style: {
      base: {
        fontSize: "14px",
        color: "#424770",
        "::placeholder": { color: "#aab7c4" },
      },
      invalid: {
        color: "#9e2146",
      },
    },
  };


       
  // Handler functions
  const handleChange = (i, field, value) => {
    const items = [...products];
    items[i][field] = value;
    setProducts(items);
  };

  const handleQty = (i, type) => {
    const items = [...products];
    if (type === "inc") items[i].quantity += 1;
    else if (type === "dec" && items[i].quantity > 1) items[i].quantity -= 1;
    setProducts(items);
  };

  const handleRemove = (i) => {
    const items = [...products];
    items.splice(i, 1);
    setProducts(items);
  };

  // const subtotal = products.reduce(
  //   (acc, item) => acc + item.discountedPrice * item.quantity,
  //   0
  // );

  function getItemPrice(item) {
    const priceCandidates = [
      item.price,
      item.unit_price,
      item.product_price,
      item.product?.discount_price,
      item.product?.product_price,
      item.product?.discount_price,
    ];
    for (const p of priceCandidates) {
      const n = Number(p);
      if (!Number.isNaN(n)) return n;
    }
    return 0;
  }
  function computeSubtotal() {
    return cartItems.reduce((sum, it) => {
      const qty = Number(it.quantity || it.qty || it.count) || 1;
      return sum + getItemPrice(it) * qty;
    }, 0);
  }

  return (
    <div className="dashboard w-full min-h-screen flex">
      <Leftsidebar />

      <main className="flex-1 min-w-0 p-4 md:p-6 md:pl-8">
        <LeftResponsivesidebar />
        <Headmenu />
        <div className="bg-white rounded-2xl p-3 md:p-6 w-full mx-auto shadow-sm">
          {/* Back Button */}
          <div className="mb-6">
            <button
              onClick={() =>
                window.history.length > 1 ? navigate(-1) : navigate("/addshopperaddress")
              }
              className="text-sm text-[#095228] font-semibold"
            >
              ← BACK
            </button>
          </div>

          {/* Main Layout */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Left: Product List */}

            <div className="lg:col-span-2 space-y-4 md:px-3">
              <div className="space-y-4">
                <div className="space-y-1 border-2 rounded-3xl md:rounded-full px-5 md:px-8 py-3">
                  <p className="text-xl text-[#095228] font-bold">Order No</p>
                  <p>{order?.order_number}</p>
                </div>
                <div className="space-y-1 border-2 rounded-3xl md:rounded-full px-5 md:px-8 py-3">
                  <p className="text-xl text-[#095228] font-bold">
                    Shipping Details
                  </p>
                  {shippingAddress ? (
                    <p>
                      {shippingAddress.name && (
                        <>
                          {shippingAddress.name}
                          <br />
                        </>
                      )}
                      {shippingAddress.address_line_1}, {shippingAddress.city},{" "}
                      {shippingAddress.state}, {shippingAddress.postal_code},{" "}
                      {shippingAddress.country}.
                      <br />
                      Phone: {shippingAddress.phone}
                    </p>
                  ) : (
                    <p>No shipping address available.</p>
                  )}
                </div>
                <div className="space-y-1 border-2 rounded-3xl md:rounded-full px-5 md:px-8 py-3">
                  <p className="text-xl text-[#095228] font-bold">
                    Delivery Details
                  </p>
                  {shippingAddress ? (
                    <p>
                      {shippingAddress.name && (
                        <>
                          {shippingAddress.name}
                          <br />
                        </>
                      )}
                      {shippingAddress.address_line_1}, {shippingAddress.city},{" "}
                      {shippingAddress.state}, {shippingAddress.postal_code},{" "}
                      {shippingAddress.country}.
                      <br />
                      Phone: {shippingAddress.phone}
                    </p>
                  ) : (
                    <p>No shipping address available.</p>
                  )}
                </div>
              </div>{" "}
              {/* Ordered Products */}
              <div className="border rounded-xl mt-6">
                {!hasOrder && (
                  <p className="p-4 text-sm text-gray-500">
                    No order details found. Please go back to the shipping page and press Pay Now.
                  </p>
                )}
                {allItems.map((item, index) => (
                  <div
                    key={index}
                    className="flex justify-between items-center p-4 border-b-2"
                  >
                    <div className="flex w-full items-center gap-4">
                      <div className="w-1/4">
                        <img
                          src={imageByProductId[item.product_id] || "/image/shoeimg.png"}
                          alt={item.product_name}
                          className="w-36 h-36 object-contain rounded-md"
                        />
                      </div>
                      <div className="w-3/4">
                        <div className="flex justify-between">
                          <h3 className="text-sm font-semibold">
                            {item.product_name}
                          </h3>
                        </div>

                        <div className="text-xs text-black font-bold mt-2">
                          <p className="w-[160px] p-2 rounded-xl border-[3px] mt-1 border-green-500 text-center">
                            {item.seller?.name}
                          </p>
                        </div>

                        <div className="flex justify-between items-center mt-3">
                          <p className="text-sm text-gray-600">
                            Qty: {item.quantity}
                          </p>
                          <p className="font-bold text-[#095228]">
                            {currencySymbol}{Number(item.total_price || 0).toFixed(2)}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Right: Order Summary */}
            <div className="border rounded-2xl p-4 md:p-6 bg-white shadow-sm h-fit">
              <h3 className="text-xl font-semibold mb-4">Order Summary</h3>
              <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span>Subtotal</span>
                  <span className="font-bold">{currencySymbol}{subtotal}</span>
                </div>
                <div className="flex justify-between">
                  <span>Delivery</span>
                  <span className="font-bold">{currencySymbol}{delivery}</span>
                </div>
                <div>
                  <div className="flex justify-between">
                    {taxBreakdown.length > 0 ? (
                      <button type="button" onClick={() => setShowTaxDetails((open) => !open)} className="text-left">
                        Tax <span className="text-xs text-gray-500">{showTaxDetails ? "▲" : "ⓘ"}</span>
                      </button>
                    ) : (
                      <span>Tax</span>
                    )}
                    <span className="font-bold">{currencySymbol}{tax}</span>
                  </div>
                  {showTaxDetails &&
                    taxBreakdown.map((rule, index) => (
                      <div key={index} className="pl-3 text-xs text-gray-600">
                        <div className="flex justify-between">
                          <span>{rule.name} ({rule.rate}%)</span>
                          <span>{currencySymbol}{rule.amount.toFixed(2)}</span>
                        </div>
                        {Object.values(rule.components).map((component) => (
                          <div key={component.name} className="flex justify-between pl-3">
                            <span>{component.name} ({component.rate}%)</span>
                            <span>{currencySymbol}{component.amount.toFixed(2)}</span>
                          </div>
                        ))}
                      </div>
                    ))}
                </div>
                <hr />
                <div className="flex justify-between font-bold text-lg">
                  <span>Total</span>
                  <span>{currencySymbol}{total}</span>
                </div>
              </div>
              <div className="mt-4 text-sm">
                <label className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    checked={useWallet}
                    disabled={payLoading || !hasOrder || (!useWallet && (availableCoins <= 0 || !walletRate))}
                    onChange={(e) => setUseWallet(e.target.checked)}
                  />
                  <span>
                    Use wallet coins{" "}
                    <span className="text-gray-500">
                      {availableCoins <= 0
                        ? "(No coins available)"
                        : !walletRate
                          ? `(Not available for ${orderCurrency} orders right now)`
                          : `($${availableCoins.toFixed(2)} available${
                              walletRate !== 1 ? ` ≈ ${currencySymbol}${coinsValue.toFixed(2)}` : ""
                            })`}
                    </span>
                  </span>
                </label>
                {walletRate && coinsValue < orderTotal && (
                  <a
                    href="/wallet"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block mt-1 ml-6 text-[#095228] font-semibold underline"
                  >
                    Add money to wallet
                  </a>
                )}
                {useWallet && (
                  <div className="space-y-1 mt-2">
                    <div className="flex justify-between">
                      <span>
                        Wallet coins applied
                        {walletRate && walletRate !== 1 && (
                          <span className="text-gray-500"> (${walletCoinsUsed.toFixed(2)})</span>
                        )}
                      </span>
                      <span className="font-bold">-{currencySymbol}{walletApplied.toFixed(2)}</span>
                    </div>
                    <div className="flex justify-between">
                      <span>Remaining to pay</span>
                      <span className="font-bold">{currencySymbol}{amountToPay.toFixed(2)}</span>
                    </div>
                  </div>
                )}
              </div>

               {/* Payment UI: render CardElement for card payments */}
              {amountToPay > 0 && (
                <div className="mt-4">
                  <label className="block text-sm font-medium mb-2">Card Details</label>
                  <div className="p-3 border rounded">
                    <CardElement options={cardElementOptions} />
                  </div>
                </div>
              )}

              {paymentStatus && (
                <p className={`mt-3 text-sm ${paymentSucceeded ? "text-green-700" : "text-red-600"}`}>
                  {paymentStatus}
                </p>
              )}

              <button
                onClick={handlePayNow}
                disabled={payLoading || !hasOrder}
                className={`mt-6 w-full ${payLoading || !hasOrder ? "opacity-70 cursor-not-allowed" : ""} bg-[#095228] text-white py-3 rounded-lg font-semibold flex items-center justify-center gap-2`}
              >
                <IoBagHandle className="text-xl" />
                {payLoading ? "Processing…" : amountToPay > 0 ? "Pay Now" : "Place Order"}
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default OrderReviewPage;

//  <div
//       className="w-full max-w-[554px] min-h-[124px] bg-white border border-[#E5E5E5] rounded-[16px] shadow-sm hover:shadow-md transition-shadow p-4 flex flex-col sm:flex-row gap-4 items-center"
//       style={{
//         fontFamily:
//           'Poppins, Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial',
//       }}
//     >
//       {/* Image */}
//       <div className="flex-shrink-0 w-full sm:w-[96px] bg-gray-50 rounded-md flex items-center justify-center overflow-hidden">
//         <img
//           src={image}
//           alt={title}
//           className="w-full sm:w-[96px] sm:h-[96px] object-contain"
//         />
//       </div>

//       {/* Title + variant */}
//       <div className="flex-1 min-w-0">
//         <div className="text-sm font-medium text-gray-900 truncate">
//           {title}
//         </div>
//         {item?.variant_name && (
//           <div className="text-xs text-gray-500 mt-1 truncate">
//             {item.variant_name}
//           </div>
//         )}
//       </div>

//       {/* Price */}
//       <div className="w-[100px] text-right">
//         <div className="text-sm text-gray-700">${totalPrice.toFixed(2)}</div>
//         <div className="text-xs text-gray-400">
//           ${(Number(unitPrice) || 0).toFixed(2)} each
//         </div>
//       </div>

//       {/* Quantity selector */}
//       <div className="flex flex-col items-center gap-2">
//         <div className="flex items-center border rounded-md overflow-hidden">
//           <button
//             aria-label="decrease"
//             onClick={() => changeQty(qty - 1)}
//             className="px-3 py-1 text-sm text-white bg-[#2B4E3E] hover:opacity-90"
//           >
//             -
//           </button>
//           <div className="px-3 py-1 text-sm">{qty}</div>
//           <button
//             aria-label="increase"
//             onClick={() => changeQty(qty + 1)}
//             className="px-3 py-1 text-sm text-white bg-[#2B4E3E] hover:opacity-90"
//           >
//             +
//           </button>
//         </div>
//       </div>

//       {/* Delete */}
//       {/* Delete */}
//       <button
//         onClick={() => onRemove && onRemove(item?.id)}
//         className="text-[#E63946] ml-2 p-1"
//       >
//         <HiOutlineTrash size={18} />
//       </button>
//     </div>
